import React, { useEffect, useRef, useState } from 'react';
import { ITagSearchingInputProps } from './~types/TagSearchingInputProps';
import { IGetSuggestionItemsProps } from './~types/GetSuggestionItemsProps';
import { ISearchingTag, TagName, TagType } from './~types/models/SearchingTag';
import { ContactField } from './~types/models/ConctactField';
import SuggestionsList from './suggestions-list/SuggestionsList';
import TagsList from './tags-list/TagsList';
import { INVALID_DATE } from './TagSearchingInputConstants';
import { connect } from "react-redux";

import './TagSearchingInput.css';
import { showErrorToastr } from '../../helpers/toastr-helper/ToastrHelper';
import { useTranslation } from 'react-i18next';

import { getContactsFieldByTags, getAllTriggersByTopicExternalId } from "./~store/actions/actions";
import { TopicPairStatus } from '../../../nlp/~store/models/enums/TopicPairStatus';

const TagSearchingInput = (props: ITagSearchingInputProps & IGetSuggestionItemsProps) => {

    const { t } = useTranslation();
    const [tags, setTags] = useState([...props.currentTags]);
    const [suggestions, setSuggestions] = useState([] as ISearchingTag[]);
    const [suggestionItems, setSuggestionsItems] = useState([] as string[]);
    const [isSuggestionsListVisible, setSuggestionsListVisibility] = useState(false);
    const [searchString, setSearchString] = useState("");

    const inputRef = useRef<HTMLInputElement>(null);
    const tagsRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const rootElement = document.getElementById("root");
        rootElement?.removeEventListener("click", _onClickRoot);
        rootElement?.addEventListener("click", _onClickRoot);
        document.removeEventListener("visibilitychange", _onBrowserTabChanged);
        document.addEventListener("visibilitychange", _onBrowserTabChanged);

        return () => {
            document.removeEventListener("visibilitychange", _onBrowserTabChanged);
            rootElement?.removeEventListener("click", _onClickRoot);
        }
    }, []);

    useEffect(() => {
        setTags([...props.currentTags])
        setSuggestions(props.searchingTags.filter(val => {
            if (props.repeatingTags === null || props.repeatingTags === true || val.tagName === TagName.ChatTag || val.tagName === TagName.ChannelName) {
                return val.tagType === TagType.OpeningTag;
            }
            else {
                return val.tagType === TagType.OpeningTag && tags.find(tag => tag.id === val.id) == null
            }
        }));
    }, [props.currentTags]);

    useEffect(() => {
        const rootElement = document.getElementById("root");
        rootElement?.removeEventListener("click", _onClickRoot);
        rootElement?.addEventListener("click", _onClickRoot);
        _filterSuggestions();
        return () => {
            rootElement?.removeEventListener("click", _onClickRoot);
        }
    }, [tags])

    useEffect(() => {
        tagsRef?.current?.scrollTo(tagsRef?.current.scrollWidth, 0);
        const lastTag = tags[tags.length - 1];
        const penultTag = tags[tags.length - 2];
        if (lastTag !== undefined && lastTag.tagType === TagType.OperationTag && (penultTag.tagName === TagName.Contact)) {
            if (searchString == "") {
                props.getContactsByTags?.(tags);
            }
            else {
                props.getContacts?.(searchString);
            }
        }
        else if (lastTag !== undefined && lastTag.tagType === TagType.OperationTag && (
            penultTag.tagName === TagName.ChatName ||
            penultTag.tagName === TagName.Phone ||
            penultTag.tagName === TagName.ContactName ||
            penultTag.tagName === TagName.ContactExernalId)){
            const field = _tagNameToContactField(penultTag.tagName);
            if (field !== null && field !== undefined) {
                props.getContactsFieldByTags(5, searchString, tags, field)
                    .then(items => {
                        setSuggestionsItems(items);
                    }
                    );
            }
        }
        else if (lastTag !== undefined && lastTag.tagType === TagType.OperationTag && (
            penultTag.tagName === TagName.TriggerName))
            {
            if (props.topicExternalId !== undefined && props.topicPairStatus !== undefined) {
                props.getAllTriggersByTopicExternalId(10, props.topicExternalId, searchString, null)
                    .then(val => {
                        setSuggestionsItems(val);
                    }
                );
            }
        }
    }, [searchString])

    const _tagNameToContactField = (tagName: TagName): ContactField | undefined => {
        switch (tagName) {
            case TagName.Phone:
                return ContactField.Phone;
            case TagName.ChatName:
                return ContactField.ChatName;
            case TagName.ContactName:
                return ContactField.ContactName;
            case TagName.ContactExernalId:
                return ContactField.ExternalId;
        }
    }

    const _setSuggestionsListVisibility = (isVisible: boolean) => {
        if(suggestions.length === 0) {
            setSuggestionsListVisibility(false);
            return;
        }
        setSuggestionsListVisibility(isVisible);
    }

    const _onClickRoot = (event: MouseEvent) => {
        const targetElement = event.target as Element;
        const suggestionElement = document.getElementsByClassName("suggestions-list__suggestion")[0];
        const tagSearchingInput = document.getElementById("tag-searching-input__input");
        if(suggestionElement !== undefined && targetElement !== undefined && tagSearchingInput !== undefined) {
            if(targetElement.id !== tagSearchingInput?.id && targetElement.className !== suggestionElement?.className) {
                _setSuggestionsListVisibility(false);
            }
        }
    }

    const _onBrowserTabChanged = () => {
        inputRef.current?.blur();
    }

    const _filterSuggestions = () => {
        const lastTag = tags[tags.length - 1];
        if (lastTag !== undefined && lastTag.tagType === TagType.ClosingTag) {
            var newSuggestions = props.searchingTags.filter(val => val.tagType === TagType.OpeningTag);
            if (!props.repeatingTags) {
                tags.filter(val => val.tagType === TagType.OpeningTag).forEach(tag => {
                    var index = newSuggestions.findIndex(val => val.tagName === tag.tagName);
                    if (index > -1 && newSuggestions[index].tagName !== TagName.ChatTag && newSuggestions[index].tagName !== TagName.ChannelName) {
                        newSuggestions.splice(index, 1);
                    }
                });
            }
            if (suggestions.length === newSuggestions.length && suggestions.every((v, i) => v === newSuggestions[i])) {
                return;
            }
            setSuggestions([...newSuggestions]);
        }
    }

    const _onSuggestionSelected = (searchingTag: ISearchingTag) => {
        _setSuggestionsListVisibility(false);
        if(searchingTag.tagType === TagType.ClosingTag && searchingTag.tagName === TagName.Date && searchingTag.value === t('common.period')) {
            setSearchString(_getDefaultPeriod());
            return;
        }
        
        setSearchString("");
        tags.push({...searchingTag});
        setTags([...tags]);
        
        if(searchingTag.tagType === TagType.OpeningTag){
            switch (searchingTag.tagName) {
                case TagName.Operator:
                    props.getAllOperators?.();
                    break;
                case TagName.ChannelName:
                    props.getAllChannels?.();
                    break;
                case TagName.Contact:
                    props.getContacts?.();
                    break;
                case TagName.Phone:  
                case TagName.ChatName:  
                case TagName.ContactName: 
                case TagName.ContactExernalId:
                    const field = _tagNameToContactField(searchingTag.tagName)
                    if (field !== null && field !== undefined) {
                        getContactsFieldByTags(5, searchString, tags, field)
                            .then(val => {
                                setSuggestionsItems(val);
                            }
                        );
                    }
                    break;
                case TagName.TriggerName:
                    if (props.topicExternalId !== undefined && props.topicPairStatus !== undefined) {
                        props.getAllTriggersByTopicExternalId(10, props.topicExternalId, searchString, null)
                            .then(val => {
                                setSuggestionsItems(val);
                            }
                        );
                    }
                    break;
                case TagName.MessengerExternalId:
                case TagName.MessengerNickname:
                    setSuggestionsItems([]);
                    break;
                default:
                    break;
            }
        }
        
        let newSuggestions: ISearchingTag[] = [];
        if(searchingTag.tagType === TagType.OpeningTag) {
            newSuggestions = props.searchingTags.filter(val => {
                switch(searchingTag.tagType) {
                    case TagType.OpeningTag: {
                        return val.tagType === TagType.OperationTag && searchingTag.suggestions?.includes(val.id.toString());
                    }
                }
            });
        } else {
            newSuggestions = props.searchingTags.filter(val => {
                switch(searchingTag.tagType) {
                    case TagType.OperationTag: {
                        return val.tagType === TagType.ClosingTag && tags[tags.length - 2].suggestions?.includes(val.id.toString());
                    }
                    case TagType.ClosingTag: {
                        if(props.repeatingTags === null || props.repeatingTags === true || val.tagName === TagName.ChatTag || val.tagName === TagName.ChannelName) {
                            return val.tagType === TagType.OpeningTag;
                        }
                        else {
                            return val.tagType === TagType.OpeningTag && tags.find(tag => tag.id === val.id) == null;
                        }
                    }
                }
            });
        }
        setSuggestions([...newSuggestions]);
        if(searchingTag.tagType !== TagType.ClosingTag) {
            setTimeout(() => inputRef.current?.focus(), 10);
        } else {
            setTimeout(() => {inputRef.current?.focus(); _setSuggestionsListVisibility(false)}, 10);
        }
    }

    const _createClosingTag = (tagName: TagName, value: string, externalValue: string | undefined = undefined): ISearchingTag => {
        const closingTag: ISearchingTag = {
            id: Math.max(...props.searchingTags.map(tag => tag.id)) + 1,
            tagType: TagType.ClosingTag,
            value: value,
            externalValue: externalValue,
            tagName: tagName
        };
        return closingTag;
    }

    const _onTextSelected = (text: string) => {
        const lastTag = tags[tags.length - 1];
        const penultTag = tags[tags.length - 2];

        if (penultTag !== undefined && lastTag !== undefined && penultTag.tagType === TagType.OpeningTag) {
            switch (penultTag.tagName) {
                case TagName.Date:
                    if (text) {
                        const [leftDate, rightDate] = _parsePeriodToDates(text);
                        if (leftDate !== null && rightDate !== null) {
                            const closingDateTag = _createClosingTag(TagName.Date, text, _getPeriodInUtc(leftDate, rightDate))
                            _onSuggestionSelected(closingDateTag);
                        }
                    }
                    return;
                case TagName.ChatNumber:
                    const chatId = Number.parseInt(text.replace(/\s+/g, "").replace(/\u00A0/g, ""), 10);
                    if (!Number.isNaN(chatId)) {
                        const closingChatNumberTag = _createClosingTag(TagName.ChatNumber, chatId.toString());
                        _onSuggestionSelected(closingChatNumberTag);
                    }
                    return;
                case TagName.ChannelName:
                    const channelId = Number.parseInt(text, 10);
                    if (!Number.isNaN(channelId)) {
                        const closingChannelNameTag = _createClosingTag(TagName.ChannelName, text, `${props.channels?.find(el => {return el.name === text})?.channelId ?? "0"}`);
                        _onSuggestionSelected(closingChannelNameTag);
                    }
                    return;
                case TagName.Phone:
                case TagName.ContactName:
                case TagName.ChatName:
                case TagName.ContactExernalId:
                case TagName.TriggerName:
                case TagName.Answer:
                case TagName.MessengerExternalId: 
                case TagName.MessengerNickname: 
                    if (text.length > 0) {
                        const closingCustomTag = _createClosingTag(penultTag.tagName, text);
                        _onSuggestionSelected(closingCustomTag);
                    }
                    return;
                case TagName.Operator:
                    if (text.length > 0 && props.operators?.some(op => op.name === text)) {
                        const closingCustomTag = _createClosingTag(penultTag.tagName, text);
                        _onSuggestionSelected(closingCustomTag);
                    }
                    return;
            }
        }

        if(lastTag !== undefined && lastTag.tagType !== TagType.ClosingTag) {
            return;
        }

        setSearchString("");

        const openingPhraseTag: ISearchingTag = {
            id: Math.max(...props.searchingTags.map(tag => tag.id)) + 1,
            tagType: TagType.OpeningTag,
            tagName: TagName.Phrase,
            value: t('common.phrase'),
        };
        const operationPhraseTag: ISearchingTag = {...props.searchingTags.find(tag => tag.tagType === TagType.OperationTag && tag.value == "=") ?? {} as ISearchingTag};
        const closingPhraseTag: ISearchingTag = {
            id: openingPhraseTag.id++,
            tagType: TagType.ClosingTag,
            value: text,
            tagName: TagName.Phrase,
        }
        tags.push(...[openingPhraseTag, operationPhraseTag, closingPhraseTag]);

        setSuggestions(props.searchingTags.filter(val => {
            if(props.repeatingTags === null || props.repeatingTags === true) {
                return val.tagType === TagType.OpeningTag;
            }
            else {
                return val.tagType === TagType.OpeningTag && tags.find(tag => tag.id === val.id) === undefined;
            }
        }));
    }

    const _onRemoveTagSet = (tag: ISearchingTag) => {
        setSearchString("");
        const index = tags.findIndex((t) => tag.value === t.value && tag.tagName === t.tagName);
        tags.splice(index - 2, 3);
        setTags([...tags]);
        let suggestions = [] as ISearchingTag[];
        const lastTag = tags[tags.length - 1];
        if(lastTag === undefined) {
            suggestions.push(...props.searchingTags.filter(tag => tag.tagType === TagType.OpeningTag));
            setSuggestions([...suggestions]);
        } else {
            switch(lastTag.tagType) {
                case TagType.ClosingTag: {
                    _filterSuggestions();
                }
            }
        }
    }

    const _onRemoveLastTag = (needText: boolean) => {
        _setSuggestionsListVisibility(false);
        if(tags[tags.length - 1]?.tagName === TagName.Phrase) {
            let lastTag = tags[tags.length - 1]
            _onRemoveTagSet(tags[tags.length - 1]);
            setSearchString(lastTag.value);
            return;
        }
        if(tags.length > 0) {
            let lastTag = tags.splice(tags.length - 1, 1)[0];
            setTags([...tags]);
            if(needText) {
                setSearchString(lastTag.value);
            }

            lastTag = tags[tags.length - 1];

            if(lastTag !== undefined) {
                const newSuggestions = props.searchingTags.filter(val => {
                    switch(lastTag.tagType) {
                        case TagType.OpeningTag: {
                            return val.tagType === TagType.OperationTag && lastTag.suggestions?.includes(val.id.toString());
                        }
                        case TagType.OperationTag: {
                            return val.tagType === TagType.ClosingTag && tags[tags.length - 2].suggestions?.includes(val.id.toString());
                        }
                        case TagType.ClosingTag: {
                            return val.tagType === TagType.OpeningTag;
                        }
                    }
                });
                setSuggestions([...newSuggestions]);
            } else {
                setSuggestions([...props.searchingTags.filter(val => val.tagType === TagType.OpeningTag)]);
            }
        }
        setTimeout(() => _setSuggestionsListVisibility(true), 10);
    }

    const _parsePeriodToDates = (period: string) => {
        const [leftDateString, rightDateString] = period.split("-");
        const [left, right] = 
        [
            `${leftDateString.split('.')[1]} ${leftDateString.split('.')[0]} ${leftDateString.split('.')[2]}`, 
            `${rightDateString.split('.')[1]} ${rightDateString.split('.')[0]} ${rightDateString.split('.')[2]}`
        ];
        const [leftDate, rightDate] = [new Date(left), new Date(right)];

        if(leftDate.toString() === INVALID_DATE || rightDate.toString() === INVALID_DATE) {
            showErrorToastr(t('error.invalidDateMessage'));
            return [null, null];
        }
        else {
            if(leftDate <= rightDate) {
                return [leftDate, rightDate];
            }
            else {
                showErrorToastr(t('error.leftDateLessMessage'));
                return [null, null];
            }
        }
    }

    const _getDefaultPeriod = () => {
        const today = new Date(Date.now());
        const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
        const todayMonthString = `0${today.getMonth() + 1}`.slice(-2);;
        const yesterdayMonthString = `0${yesterday.getMonth() + 1}`.slice(-2);
        const todayDayString = `0${today.getDate()}`.slice(-2);
        const yesterdayDayString = `0${yesterday.getDate()}`.slice(-2);
        return `${yesterdayDayString}.${yesterdayMonthString}.${yesterday.getFullYear()} 00:00:00-${todayDayString}.${todayMonthString}.${today.getFullYear()} 23:59:59`
    }

    const _getPeriodInUtc = (leftDate: Date, rightDate: Date) => {
        
        const leftDateMonthString = `0${leftDate.getUTCMonth() + 1}`.slice(-2);
        const rightDateMonthString = `0${rightDate.getUTCMonth() + 1}`.slice(-2);
        const leftDateDayString = `0${leftDate.getUTCDate()}`.slice(-2);
        const rightDateDayString = `0${rightDate.getUTCDate()}`.slice(-2);
        const leftDateHoursString = `0${leftDate.getUTCHours()}`.slice(-2);
        const leftDateMinutesString = `0${leftDate.getUTCMinutes()}`.slice(-2);
        const leftDateSecondsString = `0${leftDate.getUTCSeconds()}`.slice(-2);
        const rightDateHoursString = `0${rightDate.getUTCHours()}`.slice(-2);
        const rightDateMinutesString = `0${rightDate.getUTCMinutes()}`.slice(-2);
        const rightDateSecondsString = `0${rightDate.getUTCSeconds()}`.slice(-2);
        return `${leftDateDayString}.${leftDateMonthString}.${leftDate.getFullYear()} ${leftDateHoursString}:${leftDateMinutesString}:${leftDateSecondsString}-${rightDateDayString}.${rightDateMonthString}.${rightDate.getFullYear()} ${rightDateHoursString}:${rightDateMinutesString}:${rightDateSecondsString}`
    }

    const _clearFilter = () => {
        setSearchString("");
        setTags([]);
        setSuggestions(props.searchingTags.filter(val => val.tagType === TagType.OpeningTag));
        _setSuggestionsListVisibility(false);
        if(props.currentTags.length !== 0) {
            props.onClearFilter();
        }
        
    }

    return (
        <div className={`tag-searching-input__container ${props.containerClass ?? ""}`} ref={tagsRef }  onScroll={() => {_setSuggestionsListVisibility(false);}}>
            <TagsList
                tags={tags}
                onCloseTag={_onRemoveTagSet}
                operators={props.operators ?? []}
                channels={props.channels ?? []}
                contacts={props.contacts ?? []} />
            <SuggestionsList
                isSuggestionsListVisible={isSuggestionsListVisible}
                suggestions={suggestions}
                searchingTag={tags ?? []}
                onSelected={_onSuggestionSelected}
                onCloseList={() => _setSuggestionsListVisibility(false)}
                operators={props.operators ?? []}
                contacts={props.contacts ?? []}
                channels={props.channels ?? []}
                searchString={searchString} 
                suggestionItems={suggestionItems} />
            <input
                className="tag-searching-input__input"
                placeholder={(searchString.length === 0 && tags.length === 0) ? (t('common.search') + "...") : undefined}
                ref={inputRef}
                tabIndex={0}
                autoComplete="off"
                id={"tag-searching-input__input"}
                onKeyDown={(event) => {
                    if(event.key === "Enter") {
                        if(searchString.trim().length === 0 && tags.filter(tag => tag.tagType === TagType.ClosingTag).length === tags.length / 3) {
                            props.onSearch(tags);
                            _setSuggestionsListVisibility(false);
                        } else {
                            _onTextSelected(searchString.trim());
                            _setSuggestionsListVisibility(!isSuggestionsListVisible);
                        }
                    }
                    if(event.key === "Backspace") {
                        if(searchString.length > 0) {
                            setSearchString(searchString.substring(0, searchString.length));
                        } else {
                            _onRemoveLastTag(true);
                        }
                        _setSuggestionsListVisibility(true);
                    }
                    if (event.key === 'Tab') {
                        _setSuggestionsListVisibility(false);
                    }
                    if (event.key === 'ArrowDown') {
                        _setSuggestionsListVisibility(true);
                        setTimeout(() => {
                            (
                              document.querySelector(
                                ".dropdown-item"
                              ) as HTMLButtonElement
                            )?.focus();
                        }, 10);
                    }
                    if (event.key === "Escape") {
                        _setSuggestionsListVisibility(false);
                        event.currentTarget.blur();
                    }
                }}
                onFocus={() => _setSuggestionsListVisibility(true)}
                onClick={() => _setSuggestionsListVisibility(true)}
                value={searchString}
                onChange={(event) => {
                    setSearchString(event.currentTarget.value);
                }} />
                {tags.length > 0 && <div 
                    className="clear-filter"
                    onClick={() => {
                        _clearFilter();
                    }}>
                <i
                    className="material-icons"
                    tabIndex={0}
                    onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        _clearFilter();
                    }
                    }}
                >
                    clear</i>
                </div>}
        </div>
    );
}

const mapDispatchToProps = (dispatch: any): IGetSuggestionItemsProps => {
    return {
        getContactsFieldByTags: async (
            count: number,
            searchString: string = "",
            searchTags: ISearchingTag[],
            contactField: ContactField
        ) => {
            return (await getContactsFieldByTags(count, searchString, searchTags, contactField));
        },
        getAllTriggersByTopicExternalId: async (
            count: number,
            topicExternalId: string,
            searchString: string = "",
            topicPairStatus: TopicPairStatus | null,
        ) => {
            return (await getAllTriggersByTopicExternalId(count, topicExternalId, searchString, topicPairStatus));
        },
    }
};

export default connect(null, mapDispatchToProps)(TagSearchingInput);
